import { IoBookSharp } from 'react-icons/io5';
import { MdQueryStats } from 'react-icons/md';
import { ImProfile } from 'react-icons/im';
import { MdManageAccounts } from 'react-icons/md';
import { FaRegIdCard, FaLock, FaCog, FaBook } from 'react-icons/fa';

const links = [
    {
        id:1,
        text:'add books',
        path:'/',
        icon:<IoBookSharp/>
    },
    {
        id:2,
        text:'own books',
        path:'own-books',
        icon:<FaBook/>
    },
    {
        id:3,
        text:'all accounts',
        path:'all-accounts',
        icon:<MdManageAccounts/>
    },
    {
        id:4,
        text:'stats',
        path:'all-stats',
        icon:<MdQueryStats/>
    },
    {
        id:5,
        text:'profile',
        path:'profile',
        icon:<ImProfile/>
    },
    {
        id:6,
        text:'subscription',
        path:'subscription',
        icon:<FaRegIdCard/>
    },
    {
        id:7,
        text:'privacy policy',
        path:'privacy-policy',
        icon:<FaLock/>
    },
    {
        id:8,
        text:'terms & conditions',
        path:'terms',
        icon:<FaLock/>
    },
    {
        id:9,
        text:'settings',
        path:'settings',
        icon:<FaCog/>
    }
];

export default links